import { render } from "./offers.vue?vue&type=template&id=453dc5c4&scoped=true&lang=true"
import script from "./offers.vue?vue&type=script&lang=js"
export * from "./offers.vue?vue&type=script&lang=js"

import "./offers.vue?vue&type=style&index=0&id=453dc5c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453dc5c4"]])

export default __exports__